import React from 'react';

function NotFoundPage() {
  return <div>zenbidup: 404 - Page Not Found</div>;
}

export default NotFoundPage; 